import { HHIconButton } from '@hinge-health/react-component-library';
import { ContentCopyRounded } from '@mui/icons-material';

export const COPY_TO_CLIPBOARD_TEST_ID = 'copy-to-clipboard';

/**
 * Small icon button that copies `data` to the clipboard. Kept local to the
 * module (rather than importing the shell app's shared component) so the
 * module stays within its import boundary — see the README's portability
 * rules.
 */
interface CopyToClipboardProps {
  data: string;
  /**
   * Accessible name for the button. Required rather than defaulted because
   * the module copies more than one kind of value, and "Copy" alone tells a
   * screen reader user nothing about which.
   */
  label: string;
  /**
   * Overrides the default test id. Needed wherever more than one copy button
   * is on screen at once (e.g. one per row of the batch table), so each stays
   * uniquely addressable.
   */
  testId?: string;
}

export const CopyToClipboard = ({
  data,
  label,
  testId = COPY_TO_CLIPBOARD_TEST_ID,
}: CopyToClipboardProps): JSX.Element => {
  const handleClick = (): void => {
    navigator.clipboard.writeText(data);
  };

  return (
    <HHIconButton
      hhVariant="variant-bypass"
      data-testid={testId}
      aria-label={label}
      centerRipple
      onClick={handleClick}
    >
      <ContentCopyRounded />
    </HHIconButton>
  );
};
